'use client';

import React from 'react';

const BrandCard = () => {
  const brandList = [
    { name: "VLCC", image: "assets/Brand/vlcc.png" },
    { name: "RICA", image: "assets/Brand/rica.png" },
    { name: "LOTUS", image: "assets/Brand/getloo.png" },
    { name: "L'OREAL", image: "assets/Brand/Loreal.png" },
    { name: "O3+", image: "assets/Brand/O3.png" },
    { name: "Shahnaz Husain", image: "assets/Brand/Shahnaaz.png" },
  ];

  return (
    <div className="bg-[#f5f5f5] py-8 px-4 text-center -mt-2" >
      
      <h1 style={{ fontSize: '1.4rem', color: '#000000', fontFamily: 'Roboto, sans-serif', marginTop:'-20px', marginBottom:'20px'  }} className="font-bold mb-1">Our Top Brands Products for Your Beauty Care</h1>             


      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
        {brandList.map((brand, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-[2px_2px_8px_0_#ffecc0] w-full max-w-[418px] h-[165px] flex items-center justify-center overflow-hidden"
          >
            <img
              src={brand.image}
              alt={brand.name}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandCard;
